const Experience = () => {
  return (
    <section className="resume-section" id="experience">
      <div className="resume-section-content">
        <h2 className="mb-5">Experience</h2>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">Full stack Web Developer</h3>
            <div className="subheading mb-3">Freelance \ Side Project</div>

            <table className="table w-100">
              <tbody>
                <tr>
                  <td>
                    <li>
                      <h4 className="mb-0">Car Rent System</h4>
                    </li>
                  </td>
                  <td>
                    <li>
                      <h4 className="mb-0">Team Tasks Manager</h4>
                    </li>
                  </td>
                </tr>
                <tr>
                  <td>
                    <li>
                      <h4 className="mb-0">MyRecipe (Graduation Project)</h4>
                    </li>
                  </td>
                  <td>
                    <li>
                      <h4 className="mb-0">Attendance System</h4>
                    </li>
                  </td>
                </tr>
                <tr>
                  <td>
                    <li>
                      <h4 className="mb-0">Safi Food</h4>
                    </li>
                  </td>
                  <td>
                    {/* <li>
                      <h4 className="mb-0"></h4>
                    </li> */}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <p>
              <strong>Note:</strong> This Project will be displayed in Projects section when it is done
            </p> */}
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">2020 - Present</span>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">QUAD Digital Media</h3>
            <div className="subheading mb-3">Full Stack Web Developer · Full-time - Remote - Internship</div>
            <p>
              During my internship as a Front-end Developer at QUAD Digital Media, I gained valuable hands-on experience
              in web development. My responsibilities included:
              <ul>
                <li>Collaborating with the team to create visually appealing and responsive web interfaces.</li>
                <li>Implementing UI designs using React.js, Tailwind CSS, and Bootstrap.</li>
                <li>Enhancing user experiences with TypeScript and AppScript.</li>
                <li>Utilizing Git and GitHub for version control and code management.</li>
                <li>Work and Deploy developed web site on BEA Cloud Infrastructure.</li>
              </ul>
            </p>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">Nov 2023 - Present</span>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">Verozone Solutions EG</h3>
            <div className="subheading mb-3">Full Stack Web Developer · Full-time - Remote - Internship</div>
            <p>
              During my internship as a Front-end Developer at Verozone Solutions EG, I gained valuable hands-on
              experience in web development. My responsibilities included:
              <ul>
                <li>Collaborating with the team to create visually appealing and responsive web interfaces.</li>
                <li>Implementing UI designs using React.js, Tailwind CSS, and Bootstrap.</li>
                <li>Enhancing user experiences with JavaScript and CSS.</li>
                <li>Utilizing Git and GitHub for version control and code management.</li>
                <li>Contributing to the development of HTML5-based web applications.</li>
              </ul>
            </p>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">Nov 2022 - Mar 2023</span>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">OOREDOO Telecom Kuwait</h3>
            <div className="subheading mb-3">Call Center - Customer Care · Full-time - On Site</div>
            <ul>
              <li>Working on answering phones on Customer Care.</li>
              <li>Then work as a supervisor and a team leader.</li>
            </ul>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">Jan 2018 - Jul 2019</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
